module.exports = __webpack_public_path__ + "static/img/2345.7c1e6a18.png";